import { ReactNode } from 'react';
import { StyledIconWrapper, StyledFormSectionTitle } from './styles';

interface Props {
    title: string;
    icon: ReactNode;
    subtitle?: string;
    button?: ReactNode;
}

const FormSectionHeader: React.FC<Props> = ({ title, icon, subtitle, button }) => {
    const titleRow = button ? (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    gap: 8,
                }}
            >
                <StyledIconWrapper>{icon}</StyledIconWrapper>
                <StyledFormSectionTitle>{title}</StyledFormSectionTitle>
            </div>
            {button}
        </div>
    ) : (
        <div
            style={{
                display: 'flex',
                gap: 8,
            }}
        >
            <StyledIconWrapper>{icon}</StyledIconWrapper>
            <StyledFormSectionTitle>{title}</StyledFormSectionTitle>
        </div>
    );

    return (
        <header>
            {titleRow}
            {subtitle ? <p style={{ marginBottom: 0, marginTop: 6 }}>{subtitle}</p> : null}
        </header>
    );
};

export default FormSectionHeader;
